
import React, { useState, useEffect } from 'react';
import { storageService } from '../services/storage';

interface ImageWithFallbackProps {
  src: string;
  alt: string;
  className?: string;
}

const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({ src, alt, className }) => {
  const [resolvedSrc, setResolvedSrc] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let objectUrl = '';

    const resolveImage = async () => {
      if (!src) {
          setResolvedSrc('https://picsum.photos/400/300?text=No+Image');
          setIsLoading(false);
          return;
      }

      if (storageService.isStorageUrl(src)) {
        setIsLoading(true);
        try {
          const blob = await storageService.download(src);
          if (blob) {
            objectUrl = URL.createObjectURL(blob);
            setResolvedSrc(objectUrl);
          } else {
            setResolvedSrc('https://picsum.photos/400/300?text=Image+Not+Found');
          }
        } catch (err) {
          console.error('Error resolving storage image:', err);
          setResolvedSrc('https://picsum.photos/400/300?text=Error');
        } finally {
          setIsLoading(false);
        }
      } else {
        setResolvedSrc(src);
        setIsLoading(false);
      }
    };

    resolveImage();

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src]);

  if (isLoading) {
      return <div className={`${className} bg-brand-green-50 animate-pulse`} />;
  }

  return (
    <img 
      src={resolvedSrc} 
      alt={alt} 
      className={className} 
      loading="lazy"
    />
  );
};

export default ImageWithFallback;
